<template>
  <div>
    <div class="contents">
      <b-form class="filter-group row row-cols-1 row-cols-xl-auto g-2">
        <div class="col col-xl-5">
          <div class="date-search">
            <input
              type="date"
              class="form-control-lg"
              v-model="searchData.startdate"
            />
            <input
              type="date"
              class="form-control-lg"
              v-model="searchData.enddate"
            />
          </div>
        </div>

        <div class="col col-xl-7">
          <div class="row g-2">
            <div class="col-6 col-sm-3 col-md-auto">
              <select class="form-select" v-model="searchData.status">
                <option value="">
                  {{ $t("filter.common.total") }}
                </option>
                <option value="0">{{ $t("filter.common.ready") }}</option>
                <option value="1">{{ $t("filter.common.done") }}</option>
                <option value="2">{{ $t("filter.support.pending") }}</option>
              </select>
            </div>

            <div class="col-6 col-sm-3 col-md-auto">
              <select class="form-select" v-model="searchData.searchtype">
                <option value="SH_.define1_fk">
                  {{ $t("filter.admin.game_no") }}
                </option>
                <option value="P.player_pk">
                  {{ $t("filter.admin.member_number") }}
                </option>
                <option value="P.nickname">
                  {{ $t("filter.common.nickname") }}
                </option>
                <option value="O.nickname">
                  {{ $t("filter.common.shop_name") }}
                </option>
              </select>
            </div>

            <div class="col">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="searchData.searchname"
                />
                <button
                  class="btn btn-primary btn-lg icon-search"
                  type="submit"
                  value=""
                ></button>
              </div>
            </div>
          </div>
        </div>
      </b-form>

      <table class="table board toggle-xxl">
        <thead>
          <tr>
            <th class="col-auto">
              {{ $t("title.admin.game_no") }}
            </th>
            <th class="col-auto d-none d-md-table-cell">
              {{ $t("title.common.title") }}
            </th>
            <th class="col-auto">
              {{ $t("title.common.nickname") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.location") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.course") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.hole") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell">
              {{ $t("title.common.start_date") }}
            </th>
            <th class="col-auto">
              {{ $t("title.common.status") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="items.length > 0">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto">
                {{ item.define1_fk }}
              </td>
              <td class="col-auto d-none d-md-table-cell text-start">
                {{ item.title }}
              </td>
              <td class="col-auto text-start">
                <MemberInfo
                  :nickname="item.nickname"
                  :playerno="item.player_pk"
                  :no_img="true"
                />
              </td>
              <td class="col-auto d-none d-xl-table-cell shop-name">
                {{ item.shopname }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.coursename }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.hole_cnt }} / {{ item.holecount }}
              </td>
              <td class="col-auto d-none d-sm-table-cell text-date">
                {{ item.timezone_startdate | dateformat }}
              </td>
              <td class="col-auto">
                <label
                  :class="{
                    'status-standby': item.status === '0',
                    'status-done': item.status === '1',
                    'status-pend': item.status === '2',
                  }"
                  class="px-2 pointer"
                  @click="get_scorecard(item.player_pk, item.define1_fk)"
                >
                  {{
                    item.status === "0"
                      ? $t("filter.common.ready")
                      : item.status === "1"
                        ? $t("filter.common.done")
                        : $t("filter.membership.postpone")
                  }}
                </label>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="8">
                <div class="toggle-content">
                  <div class="row d-md-none">
                    <div class="col-4">
                      {{ $t("title.common.title") }}
                    </div>
                    <div class="col-8">
                      {{ item.title }}
                    </div>
                  </div>

                  <div class="row d-xl-none">
                    <div class="col-4">
                      {{ $t("title.common.location") }}
                    </div>
                    <div class="col-8 text-break shop-name">
                      {{ item.shopname }}
                    </div>
                  </div>

                  <div class="row d-xxl-none">
                    <div class="col-4">
                      {{ $t("title.common.course") }}
                    </div>
                    <div class="col-8">
                      {{ item.coursename }}
                    </div>
                  </div>

                  <div class="row d-xxl-none">
                    <div class="col-4">
                      {{ $t("title.common.hole") }}
                    </div>
                    <div class="col-8">
                      {{ item.hole_cnt }} / {{ item.holecount }}
                    </div>
                  </div>

                  <div class="row d-sm-none">
                    <div class="col-4">
                      {{ $t("title.common.start_date") }}
                    </div>
                    <div class="col-8 text-date">
                      {{ item.timezone_startdate | dateformat }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>

      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text>
          <i class="material-icons">keyboard_double_arrow_left</i>
        </template>
        <template #prev-text>
          <i class="material-icons">navigate_before</i>
        </template>
        <template #next-text>
          <i class="material-icons">navigate_next</i>
        </template>
        <template #last-text>
          <i class="material-icons">keyboard_double_arrow_right</i>
        </template>
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
    </div>

    <b-modal
      id="modal-data-correction"
      ref="modal-data-correction"
      size="xl"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t("page.admin.scoreboard") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-data-correction')"
        ></b-button>
      </template>

      <b-form @submit="onSubmit">
        <h6 class="modal-subtitle">
          {{ $t("title.membership.basic_information") }}
        </h6>
        <div
          class="row g-0 row-cols-1 row-cols-sm-2 row-cols-lg-4 table-type header-col p-keep"
        >
          <div class="col-sm">
            {{ $t("title.common.nickname") }}
          </div>
          <div class="col-sm text-nickname">
            {{ scorecardinfo.nickname }}
          </div>
          <div class="col-sm">
            {{ $t("title.common.play_format") }}
          </div>
          <div class="col-sm">
            {{ play_type(scorecardinfo.playtype) }}
          </div>

          <div class="col-sm border-bottom-lg-0">
            {{ $t("title.common.location") }}
          </div>
          <div class="col-sm shop-name border-bottom-lg-0">
            {{ scorecardinfo.shopname }}
          </div>
          <div class="col-sm">
            {{ $t("title.common.playing_date") }}
          </div>
          <div class="col-sm text-date">
            {{ scorecardinfo.timezone_date }}
          </div>
        </div>

        <h6 class="modal-subtitle mt-4">
          {{ $t("title.tournament.golfcourse score") }}
        </h6>

        <b-table-simple small bordered responsive table-class="border-bottom">
          <b-thead>
            <b-tr>
              <b-th
                sticky-column
                class="bg-black"
                :colspan="scorecardholepar.length + 2"
              >
                <p>{{ scorecardinfo.coursename }}</p>
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-th sticky-column>{{ $t("title.golfcourse.subcourse") }}</b-th>
              <b-td
                v-for="(anc, index1) in subcourselist"
                :key="index1"
                :colspan="
                  anc && subcourselist.length == index1 + 1
                    ? anc.scorecardscore.length + 1
                    : anc.scorecardscore.length
                "
              >
                {{ anc.subcoursename }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th sticky-column>{{ $t("title.common.hole") }}</b-th>
              <template v-for="(anc, index) in subcourselist">
                <b-td
                  v-for="(anc_, index2) in anc && anc.scorecardscore"
                  :key="'h' + index + index2"
                >
                  {{ anc_.hole_no }}
                </b-td>
              </template>
              <b-td class="text-nowrap">
                {{ $t("title.main.total") }}
              </b-td>
            </b-tr>

            <b-tr>
              <b-th sticky-column>{{ $t("title.common.par") }}</b-th>
              <template v-for="(anc, index) in subcourselist">
                <b-td
                  v-for="(anc_, index2) in anc && anc.scorecardscore"
                  :key="'p' + index + index2"
                >
                  {{ anc_.par }}
                </b-td>
              </template>
              <b-td>
                {{
                  parseInt(scorecardtotal.partotal1 || 0) +
                  parseInt(scorecardtotal.partotal2 || 0)
                }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th
                sticky-column
                class="bg-white"
                :colspan="scorecardholepar.length + 2"
              >
                <p>{{ $t("text.common.db_data") }}</p>
              </b-th>
            </b-tr>
            <b-tr>
              <b-th sticky-column>{{ $t("title.common.score") }}</b-th>
              <template v-for="(anc, index) in subcourselist">
                <b-td
                  v-for="(anc_, index2) in anc && anc.scorecardscore"
                  :key="'n' + index + index2"
                >
                  {{ anc_.score }}
                </b-td>
              </template>
              <b-td>
                {{
                  parseInt(scorecardtotal.shottotal1 || 0) +
                  parseInt(scorecardtotal.shottotal2 || 0)
                }}
                ({{
                  parseInt(scorecardtotal.scoretotal1 || 0) +
                  parseInt(scorecardtotal.scoretotal2 || 0)
                }})
              </b-td>
            </b-tr>
            <b-tr v-if="form.score.length > 0">
              <b-th
                sticky-column
                class="bg-white"
                :colspan="scorecardholepar.length + 2"
              >
                <p>{{ $t("text.common.file_data") }}</p>
              </b-th>
            </b-tr>
            <b-tr v-if="form.score.length > 0">
              <b-th sticky-column>{{ $t("text.common.correction") }}</b-th>

              <template v-for="(anc, index1) in subcourselist">
                <b-td
                  v-for="(anc_, index2) in anc && anc.scorecardscore"
                  :key="'s1' + index1 + index2"
                  class="px-2"
                >
                  <input
                    type="text"
                    class="form-control-sm"
                    v-model="
                      form.score[calculateScoreIndex(anc.subcourseseq, index2)]
                    "
                  />
                </b-td>
              </template>

              <b-td>
                {{
                  shot.reduce((a, b) => parseInt(a || 0) + parseInt(b || 0), 0)
                }}
                ({{
                  score.reduce(
                    (a, b) => parseInt(a || 0) + parseInt(b || 0),
                    0,
                  )
                }})
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <div class="input-group mt-4">
          <input
            type="text"
            class="form-control text-truncate"
            :value="s3_key"
          />
          <b-button
            size="lg"
            variant="secondary fs-14"
            @click="get_file(scorecardinfo.player_pk, scorecardinfo.define1_pk)"
          >
            {{ $t("text.common.file") }}
          </b-button>
          <b-button size="lg" variant="primary fs-14" @click="get_correction">
            {{ $t("text.common.correction") }}
          </b-button>
        </div>
        <textarea
          v-model="parse"
          cols="30"
          rows="10"
          class="border-top-0"
        ></textarea>
      </b-form>

      <template #modal-footer>
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.pending')"
          @click="pending(scorecardinfo.define1_pk)"
        >
          {{ $t("button.common.pending") }}
        </b-button>
        <b-button
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.reprocessing')"
          @click="reprocess(scorecardinfo.define1_pk)"
        >
          {{ $t("button.common.reprocessing") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ax from "@/api/gamedata";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "GameDataCorrectionList",

  data() {
    return {
      searchData: {
        startdate:
          this.$route.query.startdate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].startdate) ||
          this.$dayjs().add(-1, "month").format("YYYY-MM-DD"),
        enddate:
          this.$route.query.enddate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].enddate) ||
          this.$dayjs().format("YYYY-MM-DD"),
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          "SH_.define1_fk",
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        status:
          this.$route.query.status ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].status) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 20,
      items: [],
      view_hide: null,
      scorecardholepar: [],
      scorecardscore: [],
      scorecardtotal: {},
      subcourselist: [],
      scorecardinfo: [
        {
          coursename: "",
          date: "",
          nickname: "",
          playtype: "",
          shopname: "",
        },
      ],
      form: {
        score: [],
        player2_pk: 0,
        shot: [],
        hole_fk: [],
      },
      filename_: "",
      score: [],
      shot: [],
      hole_fk: [],
      s3_key: "",
      parse: "",
      correction: {},
    };
  },
  watch: {
    "searchData.startdate": function () {
      this.searchData.pageno = 1;
      this.get_correctionlist();
    },
    "searchData.enddate": function () {
      this.searchData.pageno = 1;
      this.get_correctionlist();
    },
    "searchData.status": function () {
      this.searchData.pageno = 1;
      this.get_correctionlist();
    },
    "searchData.searchtype": function () {
      // this.searchData.pageno = 1;
      // this.get_correctionlist();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.get_correctionlist();
    },
    "searchData.pageno": function () {
      this.get_correctionlist();
    },
  },
  methods: {
    calculateScoreIndex(seq, holeIdx) {
      const sequence = parseInt(seq);
      if (sequence === 2) {
        return holeIdx + 9;
      }
      return holeIdx;
    },
    get_scorecard(player_pk, define1_pk) {
      this.$bvModal.show("modal-data-correction");
      this.form.score = [];
      this.form.player2_pk = 0;
      this.form.hole_fk = [];
      this.hole_fk = [];
      this.score = [];
      this.shot = [];
      this.s3_key = "";
      this.parse = "";
      this.correction = {};
      ax.get_scorecard(player_pk, define1_pk, (flag, data) => {
        this.scorecardinfo = data.scorecardinfo;
        this.scorecardholepar = data.scorecardholepar;
        this.scorecardscore = data.scorecardscore;
        this.scorecardtotal = data.scorecardtotal;
        this.subcourselist = data.subcourselist;
        this.form.player2_pk =
          data.subcourselist[0] &&
          data.subcourselist[0].scorecardscore[0] &&
          data.subcourselist[0].scorecardscore[0].player2_pk;

        this.subcourselist.forEach((v) => {
          if (v.scorecardscore) {
            v.scorecardscore.forEach((v_) => {
              this.hole_fk.push(v_.hole_fk);
              this.form.hole_fk.push(v_.hole_fk);
            });
          }
        });

        if (!flag) alert(data.message);
      });
    },
    get_correction() {
      this.form.score = [];
      this.score = this.correction.score;
      console.log("this.correction.score", this.correction.score);
      this.correction.score.forEach((v, i) =>
        this.correction.shot[i] > 0
          ? this.form.score.push(v)
          : this.form.score.push("-"),
      );
      console.log("this.form.score", this.form.score);
      this.shot = this.correction.shot;
      this.form.shot = this.correction.shot;
    },
    get_file(player_pk, define1_pk) {
      ax.get_correctionfile(player_pk, define1_pk, (flag, data) => {
        this.correction = data;
        this.s3_key = this.correction.s3_key;
        this.parse = JSON.stringify(this.correction.parse);
        if (!flag) alert(data.message);
      });
    },
    get_correctionlist() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_correctionlist(this.searchData, (flag, data) => {
        this.total_cnt = data.correctionlistcnt;
        this.page_total = Math.ceil(data.correctionlistcnt / this.rows);
        this.items = data.correctionlist;
        if (!flag) alert(data.message);
      });
    },
    pending(define1_pk) {
      console.log("this.pend", this.form);
      ax.set_pending(define1_pk, this.form, (flag, data) => {
        alert(data.message);
        if (flag) {
          if (data.code === 200) {
            this.get_correctionlist();
          }
          this.$bvModal.hide("modal-data-correction");
        } else {
          return false;
        }
      });
    },
    reprocess(define1_pk) {
      console.log("this.reprocess", this.form);
      ax.set_reprocess(define1_pk, this.form, (flag, data) => {
        alert(data.message);
        if (flag) {
          if (data.code === 200) {
            this.get_correctionlist();
          }
          this.$bvModal.hide("modal-data-correction");
        } else {
          return false;
        }
      });
    },
    onSubmit(event) {
      event.preventDefault();
      console.log("this.form", this.form);
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },

  mounted() {
    this.get_correctionlist();
  },
  mixins: [myMixin],
};
</script>
